"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@angular/compiler");
const platform_browser_1 = require("@angular/platform-browser");
const http_1 = require("@angular/common/http");
const core_1 = require("@angular/core");
const app_component_1 = require("./src/app.component");
(0, platform_browser_1.bootstrapApplication)(app_component_1.AppComponent, {
    providers: [
        (0, core_1.provideZonelessChangeDetection)(),
        (0, http_1.provideHttpClient)()
    ],
}).catch((err) => console.error(err));
// AI Studio always uses an `index.tsx` file for all project types.
